namespace TabAurous.OMS {
    export interface RoleRow {
        RoleId?: number;
        RoleName?: string;
        ItemDiscount?: number;
        RoleKey?: string;
    }

    export namespace RoleRow {
        export const idProperty = 'RoleId';
        export const nameProperty = 'RoleName';
        export const localTextPrefix = 'OMS.Role';
        export const lookupKey = 'OMS.Role';

        export function getLookup(): Q.Lookup<RoleRow> {
            return Q.getLookup<RoleRow>('OMS.Role');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            RoleId = "RoleId",
            RoleName = "RoleName",
            ItemDiscount = "ItemDiscount",
            RoleKey = "RoleKey"
        }
    }
}
